class VivicoMotion extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.video = this.querySelector('video');
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.onVisibility = () => this.sync();
    this.onPreference = () => this.sync();
    this.observer = new IntersectionObserver(entries => {
      this.visible = entries[0].isIntersecting;
      this.sync();
    }, { threshold: 0.15 });
    this.observer.observe(this);
    document.addEventListener('visibilitychange', this.onVisibility);
    this.reduced.addEventListener('change', this.onPreference);
  }
  sync() {
    if (!this.visible || document.hidden) {
      this.video.pause(); return;
    }
    const source = this.video.querySelector('source');
    if (!source.src) { source.src = source.dataset.src; this.video.load(); }
    this.video.muted = true;
    // Respect reduced motion; keep the decoded opening frame instead of animating.
    if (this.reduced.matches) { this.video.pause(); return; }
    this.video.play().catch(() => {});
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    this.video?.pause();
    document.removeEventListener('visibilitychange', this.onVisibility);
    this.reduced?.removeEventListener('change', this.onPreference);
    this.ready = false;
  }
}
if (!customElements.get('vivico-motion')) customElements.define('vivico-motion', VivicoMotion);
